'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var Gird = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    grid-gap: 8px;\n"], ["\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    grid-gap: 8px;\n"])), function (_a) {
    var col = _a.col;
    return col !== null && col !== void 0 ? col : 1;
});
var templateObject_1;

export { Gird };
//# sourceMappingURL=styled.js.map
